import React from 'react';
import {
    Box,
    Flex,
    IconButton,
    Text,
    useColorModeValue,
} from '@chakra-ui/react';
import { FiMenu } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';

interface NavbarProps {
    onOpen: () => void;
    title?: string;
}

const Navbar = ({ onOpen, title, ...rest }: NavbarProps) => {
    const { t } = useTranslation('common');
    return (
        <Flex
            px={{ base: 4, md: 4 }}
            height="20"
            alignItems="center"
            bg={useColorModeValue('white', 'gray.900')}
            borderBottomWidth="1px"
            borderBottomColor={useColorModeValue('gray.200', 'gray.700')}
            justifyContent="space-between"
            display={{ base: 'flex', lg: 'none' }}
            {...rest}
        >
            <IconButton
                variant="outline"
                onClick={onOpen}
                aria-label="open menu"
                icon={<FiMenu />}
            />

            <Text
                fontSize="2xl"
                ml="8"
                fontFamily="monospace"
                fontWeight="bold"
                color={"#1b73e8"}
            >
                {title || t('mainName')}
            </Text>
        </Flex>
    );
};

export default Navbar;
